import { sum, values } from 'ramda';
import { controlProps } from '../../../utility/documentHandling';
import { omit } from 'Utility/ramdaReplacement';

export const docType = (
  documents: Array<IDocumentWithTypeV2<'uhdrsMotorRatingScale'>>,
  editing: string,
  view?: IView,
): TDocumentType | undefined =>
  editing
    ? documents.find(d => d._id === editing)?._type
    : view?.viewing
      ? documents.find(d => d._id === view.viewing)?._type
      : undefined;

/**
 * UHDRS Motor rating scale score - doesnt check for manual score
 * @param {object} doc - UHDRS Motor rating sacle document where the sums are counted from
 * @returns {number| 'notCounted'} Sums of the fields
 */
export const uhdrsMotorRatingScaleAutomaticScore = (doc?: IUHDRSMotorRatingScale): number | 'notCounted' => {
  if (!doc) return 'notCounted';

  const fieldCount = 31;

  const omitted = [...controlProps, 'date', 'shortTest', 'manualScore'];
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const scoreFields = values(omit(omitted, doc)).filter(v => v || v === 0);

  // Return either score calculated from the form or 'notCounted'
  return scoreFields.length < fieldCount ? 'notCounted' : sum(scoreFields);
};
